import { AnimatePresence, motion } from 'framer-motion'
import './header.scss'
import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import AppNotification from '../AppNotifications/AppNotification'
import UserEntry from '../UserEntry/UserEntrySection'
import { NavLink } from 'react-router-dom'
import { useCart } from '../../context/CartContext'
import SearchBox from '../SearchBox/SearchBoxModal'
import { useUser } from '../../context/UserContext'
import { headerUserData } from '../../interface/interfaces'

const Header = () => {

    const navigate = useNavigate()
    const { isLoggedIn } = useAuth()
    const { cartData } = useCart()

    const authBox = useRef<HTMLDivElement>(null)


    const [userEntry, setUserEntry] = useState(false)
    const [notiToggle, setNotiToggle] = useState(false);
    const [searchQuery, setSearchQuery] = useState('')
    const { currentUser, reloadUser } = useUser()

    const [userData, setUserData] = useState<headerUserData | null>(null)
    // const [menuToggle, setMenuToggle] = useState(false)


    useEffect(() => {
        var logInStatus = isLoggedIn()

        if (logInStatus && currentUser) {

            let inits = `${(currentUser.first_name[0]).toUpperCase()}${(currentUser.last_name[0]).toUpperCase()}`

            setUserData(
                {
                    initials: inits,
                    userImg: currentUser.image ? currentUser.image : '',
                    isUserImage: currentUser.image ? true : false,
                    isLoggedIn: logInStatus
                }
            )

        } else {
            setUserData(
                {
                    initials: '',
                    userImg: '',
                    isUserImage: false,
                    isLoggedIn: logInStatus
                }
            )
        }
        
        // eslint-disable-next-line
    }, [currentUser, isLoggedIn])


    useEffect(() => {
        const func = async () => {
            await reloadUser()
        }

        func()
        // eslint-disable-next-line
    }, [])



    const handleSearchInput = (value: string) => {
        setSearchQuery(value)
    }


    const openUserEntry = () => {
        setUserEntry(true)
    }

    const handleUserEntry = () => {

        if (!isLoggedIn()) {
            openUserEntry()
        } else {
            navigate('/account/profile')
        }

    }

    const goToOrders = () => {
        if (!isLoggedIn()) {
            openUserEntry()
        } else {
            navigate('/account/orders')
        }
    }

    const goToProfile = () => {
       navigate('/account/profile')
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                userEntry &&
                authBox.current &&
                !authBox.current.contains(event.target as Node)) {

                setUserEntry(false)
            }

        }


        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [userEntry]);


    const handleSearch = () => {
        navigate(`/products?search=${searchQuery}`)
    }


    return (
        <div className='header'>

            <div className='headerContent'>

                <div className='upperHeader'>
                    <NavLink to={'/'}>
                        <div className='logoArea'>
                            <div className='icon logo_initials'></div>
                            <div className='icon logo_name'></div>
                        </div>
                    </NavLink>



                    <div className='searchTab'>

                        <input className='input' placeholder=' ' value={searchQuery} onChange={(ev) => handleSearchInput(ev.currentTarget.value)}></input>


                        <AnimatePresence>
                            {searchQuery === '' && (<motion.div className='placeholder' initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.2 }}>

                                <div className='icon search'></div>
                                <div className='text'>Search</div>

                            </motion.div>)}
                        </AnimatePresence>



                        <button className='btn' onClick={handleSearch}>Search</button>


                        <SearchBox searchQuery={searchQuery}></SearchBox>
                    </div>

                    <div className='header_end_section'>

                        <div className='nav'>




                            <div className={`notiNav ${notiToggle ? 'active' : ''}`}>

                                <div className={`eachNav ${notiToggle ? 'active' : ''}`} onClick={() => setNotiToggle((prev) => !prev)}>
                                    <div className='svgicon'>
                                        <svg viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.94668 17.3299C6.43018 17.8526 7.04628 18.2746 7.74845 18.5639C8.45064 18.8532 9.22053 19.0023 9.99998 19C10.7794 19.0023 11.5493 18.8532 12.2514 18.5639C12.9537 18.2746 13.5698 17.8526 14.0533 17.3299C11.3633 17.6412 8.63662 17.6412 5.94668 17.3299ZM17.5 6.64999V7.31879C17.5 8.12154 17.7666 8.90624 18.2688 9.57409L19.4999 11.2109C20.6233 12.7062 19.7655 14.7383 17.8111 15.2104C12.7041 16.447 7.29588 16.447 2.18894 15.2104C0.234511 14.7383 -0.623259 12.7062 0.500065 11.2109L1.73116 9.57409C2.23474 8.90072 2.50196 8.11803 2.50116 7.31879V6.64999C2.50116 2.9773 5.8589 0 9.99998 0C14.1411 0 17.5 2.9773 17.5 6.64999Z" fill="#8B96A5" />
                                        </svg>


                                    </div>
                                    <div className='text'>Notifications</div>
                                </div>

                                <AnimatePresence>
                                    {notiToggle && (
                                        <motion.div className='tooltipAr'
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1, transition: { duration: 0.2, delay: 0.2 } }}
                                            exit={{ opacity: 0, transition: { duration: 0.1, delay: 0.0 } }}
                                        ></motion.div>)}
                                </AnimatePresence>

                                <AppNotification
                                    toggle={notiToggle} setToggle={setNotiToggle}
                                ></AppNotification>

                            </div>

                            <NavLink to={'/account/orders'} className={({ isActive }) => isActive ? "activeNav notmobnav" : "notmobnav"}>
                                <div className='eachNav' onClick={goToOrders}>
                                    <div className='svgicon'>
                                        <svg viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.32481 4.07143V4.75H3.26045C2.26308 4.75 1.42778 5.40505 1.32285 6.2691L0.0106721 17.1262C-0.0178663 17.3627 0.0109869 17.6017 0.0953617 17.8279C0.179737 18.054 0.317748 18.2621 0.500446 18.4388C0.683144 18.6155 0.906442 18.7567 1.15587 18.8534C1.4053 18.9501 1.67526 19 1.94828 19H18.0517C18.3247 19 18.5948 18.9501 18.8441 18.8534C19.0935 18.7567 19.3169 18.6155 19.4996 18.4388C19.6823 18.2621 19.8203 18.054 19.9046 17.8279C19.989 17.6017 20.0179 17.3627 19.9893 17.1262L18.6771 6.2691C18.6269 5.85214 18.401 5.46616 18.0432 5.18565C17.6854 4.90513 17.221 4.74994 16.7395 4.75H14.6752V4.07143C14.6752 2.99162 14.1826 1.95603 13.3059 1.19249C12.4291 0.428953 11.2399 0 9.99998 0C8.76006 0 7.57091 0.428953 6.69415 1.19249C5.81737 1.95603 5.32481 2.99162 5.32481 4.07143ZM9.99998 1.35714C9.17338 1.35714 8.38061 1.64311 7.7961 2.15214C7.21159 2.66117 6.88321 3.35155 6.88321 4.07143V4.75H13.1168V4.07143C13.1168 3.35155 12.7885 2.66117 12.2039 2.15214C11.6194 1.64311 10.8267 1.35714 9.99998 1.35714ZM6.88321 8.82143C6.88321 9.54126 7.21159 10.2317 7.7961 10.7407C8.38061 11.2497 9.17338 11.5357 9.99998 11.5357C10.8267 11.5357 11.6194 11.2497 12.2039 10.7407C12.7885 10.2317 13.1168 9.54126 13.1168 8.82143V8.14286C13.1168 7.96289 13.1989 7.79029 13.345 7.66304C13.4912 7.53578 13.6893 7.46429 13.896 7.46429C14.1026 7.46429 14.3008 7.53578 14.447 7.66304C14.5931 7.79029 14.6752 7.96289 14.6752 8.14286V8.82143C14.6752 9.90126 14.1826 10.9369 13.3059 11.7004C12.4291 12.4639 11.2399 12.8929 9.99998 12.8929C8.76006 12.8929 7.57091 12.4639 6.69415 11.7004C5.81737 10.9369 5.32481 9.90126 5.32481 8.82143V8.14286C5.32481 7.96289 5.40691 7.79029 5.55304 7.66304C5.69916 7.53578 5.89736 7.46429 6.10401 7.46429C6.31067 7.46429 6.50886 7.53578 6.65499 7.66304C6.80112 7.79029 6.88321 7.96289 6.88321 8.14286V8.82143Z" fill="#8B96A5" />
                                        </svg>


                                    </div>
                                    <div className='text'>Orders</div>
                                </div>
                            </NavLink>

                            <NavLink to={'/cart'} className={({ isActive }) => isActive ? "activeNav" : ""}>
                                <div className={`eachNav`}>

                                    <div className='svgicon'>

                                        <div className='carticonside'>
                                            {cartData.length >= 1 && (<div className='cartnum'>{cartData.length}</div>)}
                                            <svg viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.99778 15.2C4.89819 15.2 4.00852 16.055 4.00852 17.1001C4.00852 18.145 4.89819 19 5.99778 19C7.09738 19 7.99704 18.145 7.99704 17.1001C7.99704 16.055 7.09738 15.2 5.99778 15.2ZM0 0.950002C0 1.4725 0.449834 1.9 0.999629 1.9H1.99926L5.59793 9.11049L4.24843 11.4285C3.51869 12.7015 4.47835 14.25 5.99778 14.25H16.9937C17.5435 14.25 17.9934 13.8225 17.9934 13.3C17.9934 12.7775 17.5435 12.3501 16.9937 12.3501H5.99778L7.09738 10.45H14.5446C15.2943 10.45 15.9541 10.0605 16.294 9.4715L19.8726 3.306C20.2425 2.67901 19.7627 1.9 19.0029 1.9H4.20844L3.53869 0.541503C3.37875 0.209 3.01888 0 2.63902 0H0.999629C0.449834 0 0 0.427501 0 0.950002ZM15.9941 15.2C14.8945 15.2 14.0048 16.055 14.0048 17.1001C14.0048 18.145 14.8945 19 15.9941 19C17.0937 19 17.9934 18.145 17.9934 17.1001C17.9934 16.055 17.0937 15.2 15.9941 15.2Z" fill="#8B96A5" />
                                            </svg>

                                        </div>


                                    </div>
                                    <div className='text'>My Cart</div>
                                </div>
                            </NavLink>



                            {/* <div className='menuIcon'>
                                <div className='line'></div>
                                <div className='line'></div>
                                <div className='line'></div>
                            </div> */}


                            {userData && (<>
                                {userData.isLoggedIn && (


                                   
                                        <div className='myaccount' onClick={goToProfile}>

                                            {userData.isUserImage && (<img className='userImg' src={userData.userImg} alt='userImg'></img>)}

                                            {!userData.isUserImage && (<div className='userInitials'>
                                                {userData.initials}
                                            </div>)}

                                        </div>
                                   

                                )}


                                {!userData.isLoggedIn && (

                                    <div className={`eachNav`} onClick={handleUserEntry}>

                                        <div className='svgicon'>
                                            <svg viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 10C12.7625 10 15 7.7625 15 5C15 2.2375 12.7625 0 10 0C7.2375 0 5 2.2375 5 5C5 7.7625 7.2375 10 10 10ZM10 11.5C6.6625 11.5 0 13.175 0 16.5V17.75C0 18.4375 0.5625 19 1.25 19H18.75C19.4375 19 20 18.4375 20 17.75V16.5C20 13.175 13.3375 11.5 10 11.5Z" fill="#8B96A5" />
                                            </svg>
                                        </div>
                                        <div className='text'>My Profile</div>
                                    </div>

                                )}
                            </>)}







                            {/* <div className='eachNav' onClick={handleUserEntry}>
                                <div className='svgicon'>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M10 10.6001C12.7625 10.6001 15 8.3626 15 5.6001C15 2.8376 12.7625 0.600098 10 0.600098C7.2375 0.600098 5 2.8376 5 5.6001C5 8.3626 7.2375 10.6001 10 10.6001ZM10 12.1001C6.6625 12.1001 0 13.7751 0 17.1001V18.3501C0 19.0376 0.5625 19.6001 1.25 19.6001H18.75C19.4375 19.6001 20 19.0376 20 18.3501V17.1001C20 13.7751 13.3375 12.1001 10 12.1001Z" fill="#8B96A5" />
                                    </svg>
                                </div>
                                <div className='text'>Profile</div>
                            </div> */}

                        </div>

                        {/* <div className='language'>
                            <div className='icon eng'></div>
                            <div className='text'>EN</div>
                            <div className='icon down'></div>
                        </div> */}


                        {/* <div className='menu'>

        </div> */}

                    </div>
                </div>


                <div className='searchTabTwo'>

                    <input className='input' placeholder='' value={searchQuery} onChange={(ev) => handleSearchInput(ev.currentTarget.value)}></input>

                    <AnimatePresence>
                        {searchQuery === '' && (<motion.div className='placeholder' initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.2 }}>

                            <div className='icon search'></div>
                            <div className='text'>Search</div>

                        </motion.div>)}
                    </AnimatePresence>

                    <button className='btn' onClick={handleSearch}>Search</button>

                    <SearchBox searchQuery={searchQuery}></SearchBox>
                </div>







            </div>

            <UserEntry toggle={userEntry} setToggle={setUserEntry}></UserEntry>

        </div>
    )

}

export default Header;